import React, { Component } from "react";
import axios from "axios";

import { Puff } from 'react-loading-icons';
import { AiOutlineDownload } from "react-icons/ai";


import Scrollspy from 'react-scrollspy';

import './StudyComponents.css';
import Timeline from '../timeline/TimeLine.js';


// import { FaEye, FaDownload } from 'react-icons/fa';
// import { GoGraph } from 'react-icons/go';

import Navbar from 'react-bootstrap/Navbar';

// import Boxplot from '../graphs/Boxplot.js';

import $ from 'jquery'; 

//  FOR DOWNLOAD
const participants_data_url = window.location.protocol + '//' + window.location.host + '/api_kb/get_full_participants_data/?study_id_filter=';
const column_headers_participants = [
  {
      label: 'ID',
      key: 'participant_id',
  },
  {
      label: 'Studies',
      key: 'group_investigation_id',
  },
  {
      label: 'Biological sex',
      key: 'participant_biological_sex',
  },
  {
      label: 'Race',
      key: 'participant_race',
  },
  {
      label: 'Ethnicity',
      key: 'participant_ethnicity',
  },
  {
      label: 'Geolocation',
      key: 'participant_geolocation',
  },
  {
      label: 'Age',
      key: 'participant_age',
  },
  {
      label: 'Age at event',
      key: 'participant_age_event',
  }
]

const events_data_url = window.location.protocol + '//' + window.location.host + '/api_kb/get_full_events_data/?study_id_filter=';
const column_headers_events = [
  {
      label: 'ID',
      key: 'event_id',
  },
  {
      label: 'Study ID',
      key: 'event_investigation_id',
  },
  {
      label: 'Planned Visit ID',
      key: 'event_planned_visit_id',
  },
  {
      label: 'Participant ID',
      key: 'event_participant_id',
  },
  {
      label: 'Geolocation',
      key: 'event_geolocation',
  },
  {
      label: 'T0 Event Type',
      key: 't0_event_type',
  },
  {
      label: 'Start',
      key: 'event_start',
  },
  {
      label: 'Pseudostudyparticipanttime',
      key: 'event_pseudostudyparticipanttime',
  },
  {
      label: 'Duration',
      key: 'event_duration',
  },
  {
      label: 'Unit',
      key: 'event_unit',
  },
  {
      label: 'Category',
      key: 'event_category',
  },
  {
      label: 'Type',
      key: 'event_type',
  },
  {
      label: 'Material',
      key: 'immune_exposure_material',
  },
  {
      label: 'Sample type',
      key: 'specimen_type',
  },
  {
      label: 'Disease',
      key: 'immune_exposure_disease',
  },
  {
      label: 'Disease stage',
      key: 'immune_exposure_disease_stage',
  }
]

const assays_data_url = window.location.protocol + '//' + window.location.host + '/api_kb/get_full_assays_data/?study_id_filter=';
const column_headers_assays = [
  {
      label: 'ID',
      key: 'assay_id',
  },
  {
      label: 'Study ID',
      key: 'assay_investigation_id',
  },
  {
      label: 'Participant ID',
      key: 'assay_participant',
  },
  {
      label: 'Sample ID',
      key: 'assay_event_id',
  },
  {
      label: 'Assay Type',
      key: 'assay_type',
  },
  {
      label: 'Assay Subtype',
      key: 'assay_subtype',
  },
  {
      label: 'Target Entity Type',
      key: 'assay_target_entity_type',
  },
  {
      label: 'Target Entity Substype',
      key: 'assay_target_entity_subtype',
  },
  {
      label: 'Value',
      key: 'assay_value',
  },
  {
      label: 'Unit',
      key: 'assay_value_unit',
  }
]


export default class StudyPage extends Component {

  componentDidMount(){
    document.title = "Data Access - ImmuneSpace";
  }

  constructor(props) { 
    super(props);

    this.study_id = window.location.pathname.split('/')[3];
    
    this.state = {
      loadingOverviewData: true,
      loadingTimelineData: true,
      study_id: this.study_id,
      title: '',
      study_year: '',
      // principal_investigator: '',
      // condition_studied: '',
      study_description: '',
      number_participants: '',
      number_events: '',
      number_assays: '',
      // objectives: '',
      articles: [],
      // assays: [],
      // assays_data : [],
      nodes: [],
      edges: [],
      arm_colors: [],
      timeline_warnings: [],
      selected_graph_nodes: [],
      selected_graph_edges: [],
      compare_nodes_list: [],
      can_display_timeline: false,
    };


    // GET STUDY OVERVIEW DETAILS
    async function populate_study_detail(url, el) {
        await axios
            .get(url)
            .then((response_study_detail) => {
                el.setState({
                    loadingOverviewData: false,
                    title: response_study_detail.data.title,
                    // principal_investigator: response_study_detail.data.pi,
                    study_year: response_study_detail.data.year,
                    study_description: response_study_detail.data.description,
                    // condition_studied: response_study_detail.data.condition_studied,
                    number_participants: response_study_detail.data.number_participants,
                    number_events: response_study_detail.data.number_events,
                    number_assays: response_study_detail.data.number_assays,
                    // objectives: response_study_detail.data.objectives,
                    articles: response_study_detail.data.pubmed,
                    // assays: response_study_detail.data.assays,
                    // assays_data: response_study_detail.data.assays_data,
                });
            });
    }


    // GET TIMELINE DATA
    async function get_timeline_data(url, el){
      await axios
        .get(url)
        .then((response_timeline) => {
            el.setState({
                loadingTimelineData: false,
                nodes: response_timeline.data.nodes[0],
                edges: response_timeline.data.edges[0],
                arm_colors: response_timeline.data.arm_colors,
                timeline_warnings: response_timeline.data.timeline_warnings,
                can_display_timeline: response_timeline.data.can_display,
                selected_graph_nodes: response_timeline.data.nodes[0].combined_graph,
                selected_graph_edges: response_timeline.data.edges[0].combined_graph,
            })
        })


    }


    if (this.state.loadingOverviewData || this.state.loadingTimelineData) {

        // get study overview details
        const url_overview = window.location.protocol + '//' + window.location.host + '/api_kb/get_investigation_details/'+ this.study_id;
        populate_study_detail(url_overview, this);

        // get timeline data
        const url_timeline = window.location.protocol + '//' + window.location.host + '/api_kb/build_study_timeline/'+ this.study_id;
        get_timeline_data(url_timeline, this);

    }

  }

  expandGraphs = (assay_group_id) => {
    if ($("#visualization-" + assay_group_id).hasClass("shrink-assay-visualization")){
      $("#visualization-" + assay_group_id).removeClass('shrink-assay-visualization');
      $("#visualization-" + assay_group_id).addClass('expand-assay-visualization');

      $("#visu-icon-" + assay_group_id).removeClass('not-expanded');
      $("#visu-icon-" + assay_group_id).addClass('visu-expanded');
    }

    else {
      $("#visualization-" + assay_group_id).removeClass('expand-assay-visualization');
      $("#visualization-" + assay_group_id).addClass('shrink-assay-visualization');

      $("#visu-icon-" + assay_group_id).removeClass('visu-expanded');
      $("#visu-icon-" + assay_group_id).addClass('not-expanded');
    }
  }


  updateTimelineDb = (id) => {
    
    // remove class currently displayed timeline show the selected timeline
    document.getElementsByClassName('timeline-displayed')[0].classList.remove('timeline-displayed');
    document.getElementsByClassName('selected-timeline-tab')[0].classList.remove('selected-timeline-tab');

    $('#timeline-'+id).addClass('timeline-displayed');
    $('#'+id).addClass('selected-timeline-tab');
    
  }


  handleCompareNodes = (list) => {
    this.setState({
        compare_nodes_list:list,
    })
  }



  render(){
    return (
      <div className="StudyPage container">


          <Navbar fixed="top">
            <Scrollspy items={ ['study-overview', 'study-timeline', 'study-citations'] } currentClassName="is-current">
              <li><a href="#study-overview">Overview</a></li>
              <li><a href="#study-timeline">Timeline</a></li>
              <li><a href="#study-citations">Articles</a></li>
            </Scrollspy>
          </Navbar>

          <div className='study-content'>

            <div className="study-path">
              <div> 
                <a href="/"> Immunespace </a> 
                {'>'} 
                <a href={"/query/filters/?"}> Filters </a> 
                {'>'} 
                <a href="/query/results"> Results </a> 
                {'>'} {this.state.study_id} 
              </div>
            </div>

            <div className="study-title">
              <div className="study-title-id">{this.state.study_id}</div>
              <div className="study-title-text">{this.state.title}</div>
            </div>

            

            <section id="study-overview">

              <div className="study-overview-component study-tile">

                <div className="study-tile-title">OVERVIEW</div>

                <div className="study-tile-content study-tile-content-overview">

                  { (this.state.loadingOverviewData) ? (
                    <div className="loader-container-study-page">
                        <Puff stroke="#ccd8de" strokeWidth={5}/>
                        <p>Loading...</p>
                    </div>

                  ):(
                    
                    <div>

                      <div>
                        <p><strong>Title: </strong> {this.state.title}</p>
                        <p><strong>Initial release date: </strong> {this.state.study_year}</p>
                        <p>
                          <strong>Description: </strong> 
                          <br/>
                          {(this.state.study_description).replace(/<br\/>/gi, '\n')}
                        </p>
                        <p>
                          <strong>Number of participants: </strong> {this.state.number_participants} 
                          <a className="open-related-results" href={"/query/results/?study_id_filter="+this.state.study_id.toLowerCase()+'&ordering_tab=participants_tab'}> See data </a> 
                          <a href={participants_data_url+this.state.study_id}><AiOutlineDownload/></a>
                        </p>
                        <p>
                          <strong>Number of events / samples: </strong> {this.state.number_events} 
                          <a className="open-related-results" href={"/query/results/?study_id_filter="+this.state.study_id.toLowerCase()+'&ordering_tab=events_tab'}> See data </a> 
                          <a href={events_data_url+this.state.study_id}><AiOutlineDownload/></a>
                        </p>
                        <p>
                          <strong>Number of assays / assessment: </strong> {this.state.number_assays} 
                          <a className="open-related-results" href={"/query/results/?study_id_filter="+this.state.study_id.toLowerCase()+'&ordering_tab=assays_tab'}> See data </a> 
                          <a href={assays_data_url+this.state.study_id}><AiOutlineDownload/></a>
                        </p>
                        <p><a href={"https://www.immport.org/shared/study/"+this.state.study_id}>See on Immport</a></p>
                      </div>

                    </div>
                    
                  )}

                </div>
              </div>

            </section>

      

            <section id="study-timeline">

              <div className="study-timeline-component study-tile">

                <div className="study-tile-title">TIMELINE</div>

                <div className="study-tile-content study-tile-content-timeline">

                  { (this.state.loadingTimelineData) ? (
                      <div className="loader-container-study-page">
                          <Puff stroke="#ccd8de" strokeWidth={5}/>
                          <p>Loading...</p>
                      </div>

                    ) : 

                    (!this.state.can_display_timeline) ? (
                    
                      <p>Database error: cannot display timeline for this study</p>
                    
                    ):
                    
                    (

                      <div>

                        <div id="displayed-timeline">

                            <div className="timeline-tabs">

                                <div id="combined-graph" className="arm-tab selected-timeline-tab" onClick={() => this.updateTimelineDb('combined-graph')}>
                                    <p>combined graph</p>
                                </div>

                                { (this.state.arm_colors !== undefined && this.state.arm_colors.length > 0) ? 

                                    this.state.arm_colors.map(arm => (
                                        <div id={arm.arm_id_normalized} className="arm-tab" onClick={() => this.updateTimelineDb(arm.arm_id_normalized)}>
                                            <p> {arm.arm_id} </p>
                                        </div>
                                    ))

                                    :
                                    
                                    ''

                                }
                            
                            </div>

                            <Timeline id="timeline-combined-graph" compare_nodes_list={this.state.compare_nodes_list} compare_nodes_callback={this.handleCompareNodes} display={true} nodes={this.state.selected_graph_nodes} edges={this.state.selected_graph_edges} arm_colors={this.state.arm_colors} />
                            
                            { (this.state.arm_colors !== undefined && this.state.arm_colors.length > 0) ? 
                                
                                this.state.arm_colors.map(arm => (
                                  (this.state.nodes[arm.arm_id] && this.state.edges[arm.arm_id]) ? 
                                  <Timeline id={"timeline-"+arm.arm_id_normalized} compare_nodes_list={this.state.compare_nodes_list} compare_nodes_callback={this.handleCompareNodes} display={false} nodes={this.state.nodes[arm.arm_id]} edges={this.state.edges[arm.arm_id]} arm_colors={this.state.arm_colors} />
                                  : ''
                                ))
                                : ''

                            }

                        </div>

                        <div className="row">

                          <div className="col-6">

                            <div className="box-info">

                              { (this.state.arm_colors !== undefined && this.state.arm_colors.length > 0) ? 

                                  this.state.arm_colors.map(arm => (
                                      
                                      <div className="arm-title-box">
                                          <input type="checkbox" id={"checkbox"+arm.arm_id_normalized} name={"checkbox"+arm.arm_id_normalized} onClick={() => { this.highlightPath('.color-'+arm.arm_id_normalized+' path', 'path-selected-'+arm.arm_id_normalized, arm.arm_color) }}/>
                                          <label for={"checkbox"+arm.arm_id_normalized}>
                                              <u style={{ textDecorationColor: arm.arm_color, textDecorationThickness:'2px' }}>
                                                  {arm.arm_id} - {arm.arm_name}
                                              </u> : 
                                              <i> {arm.arm_description}</i>
                                          </label>
                                      </div>

                                  ))
                                  : ''
                              
                              }

                            </div>

                          </div>

                          <div className="col-6">

                                { (this.state.compare_nodes_list.length > 1) ?

                                    <a className="box-info compare-nodes-action" href={"/query/results/?planned_visits="+this.state.compare_nodes_list.join('+')}>
                                        Compare
                                        <p>Planned visits to compare: {this.state.compare_nodes_list.join(', ')}</p>
                                    </a>
                                    
                                    : ''
                                }

                            </div>

                        </div>

                      </div>
                      
                    )
                    
                  } 

                </div>

              </div>
              
            </section>
            

            <section id="study-citations">
              <div className="study-citations-component study-tile">

                <div className="study-tile-title">ARTICLES</div>

                <div className="study-tile-content study-tile-content-citations">
                  <p><strong>Data from this study have been published in the following paper(s): </strong></p>

                  {this.state.articles.map(function(article, i){
                          return (
                            <div className="citations-paper">
                              <p className="paper-title"><a href={"https://pubmed.ncbi.nlm.nih.gov/"+article.pmid} target="_blank" rel="noreferrer">{article.title}</a></p>
                              <p className="paper-authors">{article.authors}</p>
                              <p className="paper-journal">{article.journal}. {article.date}</p>
                              <p className="paper-pmid">PMID: {article.pmid}</p>
                              {/* <p className="paper-count">{citation.count}</p> */}
                            </div>
                          );
                  })}

                </div>

              </div>
            </section>


          
          </div>

        </div>

    );
  }
}

// export default StudyPage;